<div class="pd60">
    <div class="fw">

        <!-- Encabezado -->
        <div class="pdb10 mgb10 border-b fw">
            <img [src]="logo" alt="" class="logoOferta">
        </div>

        <!-- Datos encabezado -->
        <div class="containerDatosEncabezado">

            <div class="w-30 containerData">
                <span class="ft16 ft500">Issued to:</span>
                <span class="mgt10">Name: {{datosFact.razonSocial}}</span>
                <span >TAX ID: {{datosFact.nif}}</span>
                <span >Address: {{datosFact.direccion}}</span>
                <span >Zip code: {{datosFact.cp}}</span>
                <span >Country: {{datosFact.pais}}</span>
                <span >Email: {{datosFact.email}}</span>
                <span >Phone: {{datosFact.tlf}}</span>
            </div>
            
            <div class="mgl20 w-30 containerData" >
                <span class="ft16 ft500">Issued by:</span>
                <span class="mgt10">Predictiva21 LLC</span>
                <span>TAX ID: EIN 352712281</span>
                <span>Address: 1908 Sawdust Rd.</span>
                <span>The woodlands.</span>
                <span>Texas 77380</span>
            </div>

            <div class="containerData w-30 mgl20">
                <span>{{compra.transaccionFecha.toDate() | date}}</span>
                <span class="breakWord">Receipt: {{id}}</span>
            </div>
        </div>

        <div  class="mgt40 containerData">
            <span class="ft16 ft500">Order details:</span>
            <span class="mgt10">Order number: {{id}}</span>
            <span>Date paid: {{compra.transaccionFecha.toDate() | date}} </span>
        </div>


        <div class="mgt30">
            <table class="fw border-t">
                <tr>
                    <th>Item</th>
                    <th class="w-50">Description</th>
                    <th class="align-end">Price</th>
                    <th class="align-end">Quantity</th>
                    <th class="align-end">Discount (%)</th>
                    <th class="align-end">Total</th>
                </tr>
                <tr>
                    <td> 1 </td>
                    <td > {{compra.cursoTitulo}}</td>
                    <td class="align-end"> {{compra.cursoPrecioOriginal}}</td>
                    <td class="align-end"> 1</td>
                    <td class="align-end"> {{compra.cursoPorcentajeDescuento}}</td>
                    <td class="align-end"> {{compra.cursoPrecioFinal }}</td>
                </tr>
            </table>

            <div class="fw pd05 border-b align-end">
                <span class="ft500">Total USD: {{compra.cursoPrecioFinal }}</span>
          </div>

        </div>
    </div>
